import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { UmrahPaperRequest } from '../types/UmrahPaperRequest';

export default {
  toFirestore(umrahPaperRequest: UmrahPaperRequest): firestore.DocumentData {
    return umrahPaperRequest;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): UmrahPaperRequest {
    const data = snapshot.data()!;
    return {
      id: data.id,
      idNumber: data.idNumber,
      name: data.name,
      date: data.date,
      dateRequested: data.dateRequested,
      file: data.file,
      status: data.status,
      lastUpdate: typeof(data.lastUpdate) === 'string' ? data.lastUpdate : DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate()).toISO()
    };
  }
};
